interface Props {
  message: string;
}

/** A learning tab with nothing in it yet. */
export const EmptyTab = ({ message }: Props) => (
  <p className="rounded-2xl border border-border-secondary bg-card py-16 text-center text-muted-foreground">
    {message}
  </p>
);
